<template>
  <div class="status-icon-container"
       :class="{'smd-form__row justify-content-center align-items-center': showStatusText}">
    <span :style="styles"
          :class="[icon]"
          class="status-icon">
      <span class="path1"></span>
      <span class="path2"></span>
    </span>
    <text-string v-if="showStatusText"
                 :label-id="orderStatusTextLabelId"
                 :class="statusComputedClass"
                 class="status-icon-text"/>
  </div>
</template>

<script>
  import {STATUS_CODES, PARTNER_TYPES} from '@/reference/medicine';
  import {
    orderStatusLabelId,
  } from '@/utils/medicine';

  export default {
    name: 'status-icon',
    props: {
      item: {type: Object, required: true},
      size: {type: Number, default: 36},
      showStatusText: {type: Boolean, default: false}
    },
    computed: {
      icon() {
        switch (this.item.status) {
          case STATUS_CODES.PROC_FAILED_DELIVERY:
          case STATUS_CODES.AWAITING_PAYMENT:
          case STATUS_CODES.PENDING:
            return 'ns-icon-ico015';

          case STATUS_CODES.CANCELLED:
          case STATUS_CODES.FAILED_PAYMENT:
          case STATUS_CODES.FAILED_TO_CONTACT:
          case STATUS_CODES.FAILED_DELIVERY:
          case STATUS_CODES.AREA_NOT_SERVICEABLE:
          case STATUS_CODES.CONTACT_CANCELLATION:
          case STATUS_CODES.OUTOFSTOCK:
          case STATUS_CODES.EXPIRED:
          case STATUS_CODES.FAILED:
            return 'ns-icon-ico016';

          case STATUS_CODES.CONFIRMED:
            return this.item.ordertype === PARTNER_TYPES.diagnostics ? 'ns-icon-ico030' : 'ns-icon-ico015';

          case STATUS_CODES.FULFILLED:
            return 'ns-icon-ico017';

          case STATUS_CODES.PROCESSING:
          case STATUS_CODES.FOR_FOLLOW_UP:
          default:
            return 'ns-icon-ico032';
        }
      },
      statusComputedClass() {
        return `status-${this.item.status}`
      },
      styles() {
        return {
          fontSize: `${this.size}px`,
        };
      },
      orderStatusTextLabelId() {
        return orderStatusLabelId(this.item.status);
      },
    },
  }
</script>

<style lang="scss">

  .status-icon-container {

    .status-icon-text {

      &.status-1,
      &.status-7,
      &.status-8,
      &.status-4 {
        > span {
          color: color(carrotOrange) !important;
        }
      }

      &.status--16,
      &.status--5,
      &.status--1,
      &.status--2,
      &.status--4,
      &.status--3,
      &.status--7,
      &.status--10,
      &.status--99 {
        > span {
          color: color(crimson) !important;
        }
      }

      &.status-2,
      &.status-3,
      &.status-5,
      &.status-6 {
        > span {
          color: color(mountainGreen) !important;
        }
      }
    }
  }


</style>
